import { c as _c } from "react/compiler-runtime";
import { useAffiliateDashboardStatistic } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-statistic';
import { getAffiliateActivity } from 'modules/affiliate/utils/get-affiliate-activity';

/*
 * Whether the affiliate has earned or referred anything at all, which picks the "yet" empty states
 * over the "for this period" ones. It reads the unfiltered statistic because the page's own one is
 * narrowed to the selected vendor. SWR shares the request between every caller.
 */
export const useAffiliateActivity = () => {
  const $ = _c(6);
  const {
    data,
    error
  } = useAffiliateDashboardStatistic();
  let t0;
  if ($[0] !== data) {
    t0 = data && getAffiliateActivity(data);
    $[0] = data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activity = t0;
  const t1 = activity?.hasCommissions;
  const t2 = activity?.hasLeads;
  const t3 = !data && !error;
  let t4;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
    t4 = {
      hasCommissions: t1,
      hasLeads: t2,
      isLoading: t3
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};